<template>
  <el-col :span="8" style="height: 100%;">
      <div class="conversion">
            <div class="head">
                <p class="txt">会员数分布情况</p>
            </div>
            <div class="menberCharts">
                <!-- 顶部进度条 -->
                <div class="progress">
                    <div class="item">
                        <span class="txt">其他会员</span>
                        <el-progress :percentage="percentage" color="#FE4D45"></el-progress>
                    </div>
                    <div class="item">
                        <span class="txt">二星会员</span>
                        <el-progress :percentage="percentage" color="#FFA500"></el-progress>
                    </div>
                    <div class="item">
                        <span class="txt">四星会员</span>
                        <el-progress :percentage="percentage" color="#5882FB"></el-progress>
                    </div>
                </div>
                <!-- 图表 -->
                <div ref="menberChart" :style="{ height: '240px'}"></div>
            </div>
      </div>
  </el-col>
</template>

<script>
export default {
    data() {
        return {
            percentage: 50,
            myCharts: null
        }
    },
    mounted() {
        this.drawMenber();
        // window.addEventListener('resize', () => {
        //     this.myCharts.resize();
        // })
    },
    methods: {
        /**
         * 初始化图表
         */
        drawMenber() {
            this.myCharts = this.$echarts.init(this.$refs.menberChart);
            let options = {
                tooltip: {
                    trigger: 'item',
                    show: true
                },
                radar: [{
                    // 雷达维度
                    indicator: [
                        {
                            text: '一星会员'
                        },
                        {
                            text: '二星会员'
                        },
                        {
                            text: '三星会员'
                        },
                        {
                            text: '四星会员'
                        },
                        {
                            text: '五星会员'
                        },
                        {
                            text: '其他会员'
                        }
                    ],
                    center: ['50%', '50%'], // 位置
                    radius: 100, //大小
                    startAngle: 120,
                    splitNumber: 4,
                    shape: 'rect', // 雷达样式图
                    name: {
                        formatter: '{value}',
                        textStyle: {
                            fontSize:12,
                            color: '#999' // 文字颜色
                        }
                    },
                    splitArea: {
                        areaStyle: {
                            color: ['rgba(254, 77, 69, 0.4)', 'rgba(254, 77, 69, 0.25)', 'rgba(254, 77, 69, 0.15)', 'rgba(254, 77, 69, 0.05)'], //圆环颜色
                            shadowColor: '#FE4D45', // 圆颜色
                            shadowBlur: 10
                        }
                    },
                    axisLine: {   // 坐标轴线
                        lineStyle: {
                            width : 1,
                            color: 'rgba(254, 77, 69, 0.05)'// // 图表背景网格线的颜色
                        }
                    },
                    splitLine: { //     // 网格线
                        lineStyle: {
                            width : 1,
                            color: 'rgba(254, 77, 69, 0.15)'
                        }
                    }
                }],
                series: [{
                    name: '会员数分布',
                    type: 'radar',
                    smooth: true,
                    itemStyle: {
                        emphasis: {
                            color: '#FE4D45',
                            lineStyle: {
                                width: 2
                            }
                        }
                    },
                    data: [{
                        value: [1234, 2222, 789, 333, 1780, 2888],
                        symbolSize: 6,
                        areaStyle: {
                            normal: {
                                color: 'rgba(255,255,255,.6)' // 选择区域颜色
                            }
                        },
                        lineStyle: {
                            color: '#FE4D45', // 雷达构成的区域边框
                        }
                    }]
                }]
            }
            this.myCharts.setOption(options)
        },
    }
}
</script>

<style scoped lang="scss">
.conversion {
    display: flex;
    flex-direction: column;
    height: 360px;
    background:rgba(255,255,255,1);
    box-shadow:0px 4px 8px rgba(0,0,0,0.06);
    border-radius:6px;
    .head {
        flex-shrink: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        height: 54px;
        padding: 0 20px 0 24px;
        border-bottom: 1px solid #f6f6f6;
        .txt {color: #252C38; font-size: 16px; font-weight: 800; margin: 0;}
    }
    .menberCharts {
        flex: 1;
        box-sizing: border-box;
        padding: 17px 23px 30px;
        .progress {
            display: flex;
            .item {
                flex: 1;
                height: 50px;
                .txt {
                    color: #999;
                    font-size: 13px;
                }
            }
        }
    }
}
</style>
<style lang="scss">
.conversion {
    .menberCharts {
        .item {
            .el-progress-bar__outer {
                height: 4px !important;
            }
            .el-progress__text {
                opacity: 0;
            }
        }
    }
}
</style>